import { LuAlignJustify, LuChevronDown, LuUser2, LuX } from "react-icons/lu";
import {
  RiHome2Line,
  RiLogoutBoxLine,
  RiShipLine,
  RiSignpostLine,
} from "react-icons/ri";
import {
  AiOutlineHome,
  AiOutlinePushpin,
  AiOutlineSafetyCertificate,
} from "react-icons/ai";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "../../../assets/img";
import { useGlobalState } from "../../../context/GlobalStateContext";
import { SITELINKS } from "../../../app-routes/links";
import { FaBell, FaShip, FaSignsPost } from "react-icons/fa6";
import apiClient from "../../../api-services/ApiClient";
import { useEffect, useRef, useState } from "react";
import Preloader from "../../../app-components/preloader/Preloader";
import DOMPurify from "dompurify";
import { APP_AUTH_LOGOUT } from "../../../api-services/Process";

const HeaderMarine = () => {
  const { state } = useGlobalState();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isOpenNotification, setIsOpenNotification] = useState(false);
  const [isOpenPOption, setIsOpenPOption] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const openSearch = () => setIsSearchOpen(true);
  const closeSearch = () => {
    setIsSearchOpen(false);
    setSearchQuery("");
  };

  const handleSearch = () => {
    console.log("Searching for:", searchQuery);
    closeSearch();
  };

  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const notificationRef = useRef<HTMLDivElement | null>(null);
  const searchRef = useRef<HTMLDivElement | null>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpenPOption(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close notification dropdown when clicking outside
  useEffect(() => {
    const handleClickOutsideNotification = (event: MouseEvent) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target as Node)
      ) {
        setIsOpenNotification(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideNotification);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideNotification);
    };
  }, []);

  // Close notification dropdown when clicking outside
  useEffect(() => {
    const handleClickOutsideSearch = (event: MouseEvent) => {
      if (
        searchRef.current &&
        !searchRef.current.contains(event.target as Node)
      ) {
        setIsSearchOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideSearch);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideSearch);
    };
  }, []);

  useEffect(() => {
    getAllNotifications();
  }, []);

  const getAllNotifications = async () => {
    setLoading(true);

    try {
      const res: any = await apiClient.get("NotificationMessage");
      setNotifications(res.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  
  // handle-login-submit
  const handleLogout = async () => {
    setLoading(true);
    try {
      const login_url = new URL(window.location.origin + SITELINKS.SIGNIN);
      login_url.searchParams.append("azureauthredirect", "1");

      window.location.replace(
        APP_AUTH_LOGOUT + window.encodeURIComponent(login_url.href)
      );
    } catch (error: any) {
      console.log(JSON.stringify(error));
    } finally {
      setLoading(false);
    }
  };

  const sanitizeHTML = (html: string | undefined) => {
    return { __html: DOMPurify.sanitize(html || "") };
  };

  const toggleDropdown = () => {
    setIsOpenNotification(!isOpenNotification);
  };

  return (
    <header className="bg-white shadow fixed top-0 w-full z-50">
      <div className="xl:container md:px-4 flex items-center justify-between gap-4 mx-auto">
        <div className="flex justify-start items-center 2xl:gap-16 gap-10">
          {/* logo area */}
          <div className="flex items-center py-2">
            <div className="pr-5 xl:hidden">
              <button
                onClick={toggleSidebar}
                className="rounded p-1.5 bg-slate-200"
              >
                {isOpen ? (
                  <LuX className="text-[#191ead] mr-1" />
                ) : (
                  <span className="">
                    <LuAlignJustify className="text-2xl text-[#191ead]" />
                  </span>
                )}
              </button>
            </div>

            <img
              src={Logo}
              alt="header-logo"
              className="w-[75px] h-[42px] 2xl:w-[75px] 2xl:h-[42px] pr-3"
            />

            <div className="2xl:pl-5 xl:pl-2 xl:text-[16px] md:text-[12px] font-bold nunito">
              <p className="">Marine Vessel Inspection Portal (MVIP)</p>
            </div>
          </div>

          {/* desktop nav area */}
          <nav className="hidden">
            <ul className="flex items-center gap-8 text-[12px] text-black font-bold nunito">
              <li className="py-3">
                <Link
                  to={SITELINKS.DASHBOARD_MARINESUPERINTENDENT}
                  className="relative flex gap-2 items-center py-2 px-2 hover:bg-slate-100 rounded"
                >
                  {/* <FaHouse className="text-red-600 text-sm" /> */}
                  <span className="breadcrumb-icon-first md:tw-inline-block tw-hidden">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="none"
                      viewBox="0 0 16 16"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m2 6 6-4.667L14 6v7.333a1.334 1.334 0 0 1-1.333 1.334H3.333A1.334 1.334 0 0 1 2 13.333V6Z"
                      ></path>
                    </svg>
                  </span>

                  <span
                    className={`${
                      location.pathname ===
                      SITELINKS.DASHBOARD_MARINESUPERINTENDENT
                        ? "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full"
                        : "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100"
                    }`}
                  >
                    Dashboard
                  </span>
                </Link>
              </li>

              <li className="py-3">
                <Link
                  to={SITELINKS.INSPECTION_MARINESUPERINTENDENT}
                  className="relative flex gap-2 items-center py-2 px-2 hover:bg-slate-100 rounded"
                >
                  <FaShip className="text-red-600 text-sm" />
                  <span
                    className={`${
                      location.pathname.match("inspection")
                        ? "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full"
                        : "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100"
                    }`}
                  >
                    Vessel Inspection
                  </span>
                </Link>
              </li>

              <li className="py-3">
                <Link
                  to={SITELINKS.MARINE_ACTION_TRACKER}
                  className="relative flex gap-2 items-center py-2 px-2 hover:bg-slate-100 rounded"
                >
                  <FaSignsPost className="text-red-600 text-sm" />
                  <span
                    className={`${
                      location.pathname === SITELINKS.MARINE_ACTION_TRACKER
                        ? "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full"
                        : "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100"
                    }`}
                  >
                    Action Tracker
                  </span>
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="flex gap-4 items-center">
          {/* desktop nav area */}
          <nav className="hidden xl:flex">
            <ul className="flex items-center gap-5 text-[12px] text-black font-bold nunito">
              <li className="py-3">
                <Link
                  to={SITELINKS.DASHBOARD_MARINESUPERINTENDENT}
                  className="relative flex gap-2 items-center py-2 px-2 hover:bg-slate-100 rounded"
                >
                  <AiOutlineHome className="text-red-600 text-lg" />
                  <span
                    className={`${
                      location.pathname ===
                      SITELINKS.DASHBOARD_MARINESUPERINTENDENT
                        ? "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full"
                        : "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100"
                    }`}
                  >
                    Dashboard
                  </span>
                </Link>
              </li>

              <li className="py-3">
                <Link
                  to={SITELINKS.INSPECTION_MARINESUPERINTENDENT}
                  className="relative flex gap-2 items-center py-2 px-2 hover:bg-slate-100 rounded"
                >
                  <AiOutlineSafetyCertificate className="text-red-600 text-lg" />
                  <span
                    className={`${
                      location.pathname.match("inspection")
                        ? "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full"
                        : "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100"
                    }`}
                  >
                    Vessel Inspection
                  </span>
                </Link>
              </li>

              <li className="py-3">
                <Link
                  to={SITELINKS.MARINE_ACTION_TRACKER}
                  className="relative flex gap-2 items-center py-2 px-2 hover:bg-slate-100 rounded"
                >
                  <AiOutlinePushpin className="text-red-600 text-lg" />
                  <span
                    className={`${
                      location.pathname === SITELINKS.MARINE_ACTION_TRACKER
                        ? "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full"
                        : "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100"
                    }`}
                  >
                    Action Tracker
                  </span>
                </Link>
              </li>
            </ul>
          </nav>

          {/* search panel area */}
          <div className="flex pr-1 pl-5 hidden" ref={searchRef}>
            {/* search icon */}
            <button
              className="text-gray-700"
              aria-label="Open Search"
              onClick={isSearchOpen ? closeSearch : openSearch}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="m21 21-4.108-4.108m2.22-5.336a7.555 7.555 0 1 1-15.112 0 7.555 7.555 0 0 1 15.111 0Z"
                ></path>
              </svg>
            </button>

            <div className="relative">
              {isSearchOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-start justify-center mt-[58px] border-t animate-slideInUp">
                  <div className="bg-white w-full py-6 shadow-lg z-50">
                    <div className="xl:container xl:mx-auto 2xl:pr-[1rem] 2xl:pl-[1rem]">
                      <input
                        type="text"
                        className="w-full py-6 px-6 p-2 border-2 border-gray-700 rounded-3xl"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>

                    <div className="flex justify-between hidden">
                      <button
                        className="w-1/2 bg-blue-500 text-white p-2 rounded mr-2"
                        onClick={() => {
                          handleSearch();
                        }}
                      >
                        Action Tracker
                      </button>

                      <button
                        className="w-1/2 bg-green-500 text-white p-2 rounded ml-2"
                        onClick={() => {
                          handleSearch();
                        }}
                      >
                        Vessel Inspection
                      </button>
                    </div>
                  </div>

                  <div
                    onClick={closeSearch}
                    className="fixed inset-0 bg-black bg-opacity-50 z-10 flex items-start justify-center mt-[58px] border-t animate-slideInUp"
                  ></div>
                </div>
              )}
            </div>
          </div>

          {/* notification panel area */}
          <div className="relative pl-5" ref={notificationRef}>
            <button
              onClick={toggleDropdown}
              className="relative py-2 flex gap-2 items-center text-xs font-medium bg-gray-100 px-2 rounded-full hover:bg-slate-200 transition-colors duration-300 ease-in-out transform"
            >
              <span className="h-[9px] w-[9px] bg-red-600 absolute top-[5px] right-[8px] rounded-full border border-gray-100 border-2"></span>
              <FaBell className="text-[16px] text-gray-700" />
            </button>

            {isOpenNotification && (
              <div className="absolute right-[-15px] mt-3 w-[200px] animate-slideInUp">
                <div className="relative">
                  <div className="absolute right-6 top-0 transform -translate-y-full">
                    <div className="w-0 h-0 border-l-8 border-r-8 border-b-8 border-transparent border-b-gray-200"></div>
                  </div>

                  <div
                    className="py-2 bg-white border rounded-md shadow-lg overflow-hidden z-20"
                    style={{
                      height: "20vh",
                      overflowY: "scroll",
                      scrollbarWidth: "thin",
                    }}
                  >
                    {notifications.length === 0 ? (
                      <div className="text-gray-800 px-4 py-2 text-xs">
                        No notification
                      </div>
                    ) : (
                      notifications.map((notification: any) => (
                        <div
                          key={notification?.id}
                          className="block px-4 py-2 text-gray-900 hover:bg-gray-100 text-[9px] notification-link border-b border-1 border-[#ccc]"
                        >
                          <div
                            dangerouslySetInnerHTML={sanitizeHTML(
                              notification?.message
                            )}
                          />
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* users - info & option dropdown area */}
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setIsOpenPOption(!isOpenPOption)}
              className={`hover:bg-slate-200 py-1 flex gap-1 items-center text-xs font-medium bg-gray-100 px-3 rounded-full transition-colors duration-300 ease-in-out transform ${
                isOpenPOption &&
                "outline-[2px] outline -black rounded-t-md  rounded-b-none"
              }`}
            >
              <LuUser2 className="text-lg m-1 text-red-700" />
              <span className="whitespace-nowrap text-[12px] text-black nunito font-bold">
                Hello, {state?.tepnguser?.user?.firstName}
              </span>

              <LuChevronDown
                className={`text-lg text-red-700 transition-transform duration-500 ${
                  isOpenPOption && "rotate-180"
                }`}
              />
            </button>

            {isOpenPOption && (
              <ul
                style={{ left: "px", top: "32px" }}
                className={`absolute mt-1 space-y-1 bg-white border border-gray-300 py-2 rounded-md shadow-lg w-full left-0 z-10 text-xs animate-slideInUp ${
                  isOpenPOption && "rounded-t-none"
                }`}
              >
                {state.tepnguser.roles.find(
                  (item: any) => item === "Administrator"
                ) && (
                  <li>
                    <Link
                      to={SITELINKS.DASHBOARD_ADMIN}
                      className="block px-4 py-1 text-gray-800 hover:bg-gray-100 flex transition-colors duration-300 ease-in-out transform"
                    >
                      <span className="ml-1">Switch to Admin</span>
                    </Link>
                  </li>
                )}

                <li>
                  <Link
                    to={SITELINKS.MANUAL_MS}
                    className="block px-4 py-1 text-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 flex dark:text-gray-300 transition-colors duration-300 ease-in-out transform"
                  >
                    <span className="ml-1">User Manual</span>
                  </Link>
                </li>

                <li>
                  <Link
                    to={SITELINKS.MARINESUPERINTENDENT_VESSEL_REPORT}
                    className="block px-4 py-1 text-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 flex dark:text-gray-300 transition-colors duration-300 ease-in-out transform"
                  >
                    <span className="ml-1">Vessel Reports</span>
                  </Link>
                </li>

                <li>
                  <button
                    onClick={handleLogout}
                    className="block w-full px-4 py-1 text-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 flex dark:text-gray-300 transition-colors duration-300 ease-in-out transform"
                  >
                    <span className="ml-1">Log out</span>
                  </button>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>

      {/* pull out Sidebar */}
      <div>
        <div
          className={`fixed top-0 left-0 right-0 h-full w-5/6 md:w-2/6 bg-white dark:bg-slate-700 shadow-lg z-50 text-white transform transition-transform duration-300 ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <nav className="p-4 py-16 text-gray-700 dark:text-gray-300 font-medium text-lg overfloy-y-scroll">
            <ul className="text-[#1b1bac]">
              <div className="px-6 font-medium text-2xl pb-3 text-[#191ead]">
                <div className="flex justify-between items-center">
                  <h2>MENU</h2>
                  <button onClick={toggleSidebar} className="">
                    <LuX className="text-red-600 mr-1 text-3xl" />
                  </button>
                </div>
                <hr className="border-1 border mt-6" />
              </div>

              <li className="mb-2">
                <Link
                  to={`${SITELINKS.DASHBOARD_MARINESUPERINTENDENT}`}
                  onClick={toggleSidebar}
                  className="flex items-center gap-4 p-4 hover:bg-gray-50 dark:hover:bg-slate-800"
                >
                  <RiHome2Line className="text-3xl" />
                  <span className="mt-1">Dashboard</span>
                </Link>
              </li>

              <li className="mb-2">
                <Link
                  to={SITELINKS.INSPECTION_MARINESUPERINTENDENT}
                  onClick={toggleSidebar}
                  className="flex items-center gap-4 p-4 hover:bg-gray-50 dark:hover:bg-slate-800"
                >
                  <RiShipLine className="text-3xl" />
                  <span className="mt-1">Vessel Inspection</span>
                </Link>
              </li>

              <li className="mb-2">
                <Link
                  to={SITELINKS.MARINE_ACTION_TRACKER}
                  onClick={toggleSidebar}
                  className="flex items-center gap-4 p-4 hover:bg-gray-50 dark:hover:bg-slate-800"
                >
                  <RiSignpostLine className="text-3xl" />
                  <span className="mt-1">Action Tracker</span>
                </Link>
              </li>

              <li className="border-t absolute bottom-[50px] w-5/6">
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-4 p-4 py-6 hover:bg-gray-50 dark:hover:bg-slate-800"
                >
                  <RiLogoutBoxLine className="text-3xl" />
                  <span className="mt-1">Logout</span>
                </button>
              </li>
            </ul>
          </nav>
        </div>

        <div
          onClick={toggleSidebar}
          className={`fixed top-0 left-0 right-0 h-full w-full bg-[#00000092] dark:bg-[#00000099] shadow-lg z-40 text-white transform transition-transform duration-300 ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        ></div>
      </div>

      <Preloader loading={loading} />
    </header>
  );
};

export default HeaderMarine;
